import Paper from '@mui/material/Paper';
import React, { Fragment, useCallback, useEffect } from 'react';
import { withStyles } from 'tss-react/mui';
import StyledDivider from '../../../common/components/misc/StyledDivider';
import { useProfileQuery, useProfilesForSupervisorQuery } from '../../hooks/useProfile';
import EducatorProfileList from './EducatorProfileList';
import ProfileListItem from './ProfileListItem';
import SupervisorFilter from './SupervisorFilter';

const styles = theme => ({
  emptyPadding: {
    padding: theme.typography.pxToRem(25),
  },
});

const EducatorSidebar = ({ handleSupervisorChange, supervisor, user, classes, onProfileSelected, refreshTick, selectedItem, routeProfileId }) => {
  const [namedFilter, setNamedFilter] = React.useState('open');

  const { data: profiles, isPending } = useProfilesForSupervisorQuery(namedFilter, supervisor.id, 'created_at desc');
  const { data: profileFetchViaUrl, isPending: isPendingSelected } = useProfileQuery(routeProfileId);

  const getProfileList = useCallback(() => {

    if (!profiles || profiles.length === 0) {
      return null;
    }

    return Object.keys(profiles).map(obj => {
      var singleProfile = profiles[obj];

      return (<ProfileListItem
        key={obj}
        handleProfileItemClick={(event) => handleProfileItemClick(event, singleProfile)}
        profileItem={singleProfile}
        selectedItem={selectedItem} />
      );
    });
  }, [profiles, selectedItem]);

  const selectFirstProfileIfAvailable = useCallback(() => {
    if (profiles && profiles.length > 0) {
      onProfileSelected(profiles[0]);
    } else {
      onProfileSelected('none', null);
    }
  }, [profiles]);

  const handleFilterChange = useCallback((value) => {
    setNamedFilter(value);
  }, []);

  const handleProfileItemClick = (event, profile) => {
    onProfileSelected(profile);
  };

  useEffect(() => {
    selectFirstProfileIfAvailable()
  },[namedFilter])

  useEffect(() => {
    if (routeProfileId && profileFetchViaUrl) {
      // Need to set the namedFilter to match selected profile's status
      if (!profileFetchViaUrl?.educator_completed && !profileFetchViaUrl?.completed) {
        setNamedFilter('in_progress');
      } else if (profileFetchViaUrl?.completed) {
        setNamedFilter('resolved');
      } else {
        setNamedFilter('open');
      }
      setTimeout(() => {
        onProfileSelected(profileFetchViaUrl);
      }, 200);
    } else {
      selectFirstProfileIfAvailable();
    }
  }, [profileFetchViaUrl, routeProfileId]);



  if (!supervisor.id) {
    return (<Paper className={classes.emptyPadding}><div>This institute has no supervisors.  Educators must be assigned to a user with the supervisor role</div></Paper>);
  }

  return (
    <Fragment>
      <SupervisorFilter
        currentProfile={namedFilter}
        currentSupervisor={supervisor.name}
        handleProfileChange={handleFilterChange}
        handleSupervisorChange={handleSupervisorChange}
        user={user}
      />
      <StyledDivider />
      <EducatorProfileList
        getProfileList={getProfileList}
        profiles={profiles}
      />
    </Fragment>
  );
};

export default withStyles(EducatorSidebar, styles, { withTheme: true });
